
import React from 'react';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { recentAlarms, getSeverityColor } from '@/data/water-analytics-data';
import { Hash } from 'lucide-react';
import { formatDeviceId } from '@/components/telemetry/utils/chartUtils';

interface WaterAlarmsTableProps {
  onDeviceClick?: (device: typeof recentAlarms[0] & { generatedDeviceId?: string }) => void;
}

const WaterAlarmsTable = ({ onDeviceClick }: WaterAlarmsTableProps) => {
  return (
    <AnimatedCard 
      animation="fade-up"
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardHeader>
        <CardTitle>Recent Water System Alarms</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Device ID</TableHead>
              <TableHead>Device</TableHead>
              <TableHead>Issue</TableHead>
              <TableHead>Severity</TableHead>
              <TableHead>Time</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {recentAlarms.map((alarm) => {
              const generatedDeviceId = `WATER-${alarm.id.toString().padStart(3, '0')}`;
              return (
                <TableRow 
                  key={alarm.id}
                  className={onDeviceClick ? "cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/70 transition-colors" : ""}
                  onClick={onDeviceClick ? () => onDeviceClick({...alarm, generatedDeviceId}) : undefined}
                >
                  <TableCell className="font-mono text-xs">
                    <div className="flex items-center">
                      <Hash className="h-3.5 w-3.5 mr-1 text-muted-foreground" />
                      {formatDeviceId(generatedDeviceId)}
                    </div>
                  </TableCell>
                  <TableCell className="font-medium">{alarm.device}</TableCell>
                  <TableCell>{alarm.issue}</TableCell>
                  <TableCell>
                    <span className={getSeverityColor(alarm.severity)}>
                      {alarm.severity}
                    </span>
                  </TableCell>
                  <TableCell>{alarm.time}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </AnimatedCard>
  );
};

export default WaterAlarmsTable;
